import React from "react";
import { Box } from "app/components/common";
import { EdgeInsets, SafeAreaView } from "react-native-safe-area-context";
import {
  backgroundColor,
  border,
  spacing,
  VariantProps,
} from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";
import { useRestyle } from "@shopify/restyle";
import { composeRestyleFunctions } from "@shopify/restyle";
import { position } from "@shopify/restyle";
import { opacity } from "@shopify/restyle";
import { visible } from "@shopify/restyle";
import { layout } from "@shopify/restyle";
import { shadow } from "@shopify/restyle";

type RestyleProps = VariantProps<Theme, "boxVariants"> &
  React.ComponentProps<typeof Box>;

const restyleFunctions = composeRestyleFunctions<Theme, RestyleProps>([
  position,
  spacing,
  border,
  opacity,
  backgroundColor,
  visible,
  layout,
  shadow,
]);

type Props = RestyleProps & {
  edges?: EdgeInsets;
};

const MySafeAreaView = ({ children, edges = undefined, ...rest }: Props) => {
  const props = useRestyle(restyleFunctions, rest);

  return (
    <SafeAreaView {...props} edges={edges}>
      {children}
    </SafeAreaView>
  );
};

export { MySafeAreaView };
